export enum UserTabMode {
  Users,
  UserHistory,
  ManageUser,
  ManageUserGroups,
  ManageApplications,
  ManageMFAOptions,
  Requests,
  AssignUserWhitespaceRoles,
  AssignUserWhitespaceAuthorities,
  AssignUserHwrcRoles,
  AssignUserHwrcRegions,
  AssignUserHwrcSites
}
